<template>
<div class='container-base'>
  <h1>ヤギにはがきを渡す</h1>
  <div class='yagi-area'>
    <div class="postyagi-wrapper">
      <div class="postyagi" :class="postyagiClassObj">
        <div class="message"
             v-if="postYagiMessage">
          {{ postYagiMessage }}
        </div>
        <div class="yagi-image" @click="showClickMessage();vibrateYagi()">
          <img src="/static/img/postcard/postyagi.svg" alt="郵便ヤギ">
        </div>
      </div>
    </div>
    <el-progress :text-inside="true"
      :stroke-width="18"
      :percentage="successPercent"></el-progress>
  </div>
  <div class="postcard">
    <div class="postcard-header">
      <p v-if='$firebase.isAuthenticated'>
        やぎにはがきを渡してみましょう。なにか起こるかも。<br>
        <a :href="contactFormURL" target="_blank" rel="nofollow">🐐不具合の報告など、回答が必要なものは別途お問い合わせフォームからお送りください。</a>
      </p>
      <p v-else>やぎにはがきを渡してみましょう。</p>
    </div>
    <div class='postcard-form'>
      <el-form :model='postCard'
        :rules='postCardRules'
        @submit.native.prevent
        ref='postCardForm'
        class='input-area'
        :class="animeClass">
        <el-form-item :required='false'
          prop='content'>
          <div class="postcard-message">
            <div class="postcard-message-head">
              <span class="postage-stamp"><img src="/static/img/postcard/postcard-stamp.png"></span>
              <span class="subject">yagishへ</span>
            </div>
            <div class="postcard-message-body"
              :data-counter="postCard.content.length">
              <el-input
                type='textarea'
                :autosize='{ minRows: 3, maxRows: 7}'
                cols="3"
                autofocus
                placeholder='ここにメッセージを書いてね🍀'
                v-model='postCard.content'
                >
              </el-input>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div class='postcard-form-submit'>
        <el-button @click='passPostCard'
          v-if='!nowSending'
          type="primary"
          class="button-block">ヤギに渡す</el-button>
        <el-button disabled
          v-else><i class='el-icon-loading'></i> ちょっとまっててね</el-button>
      </div>
    </div>
  </div>
  <p class="postcard-caution">※ はがきには口に入れても安全な素材を利用しています。</p>
  <div v-if='$firebase.isAuthenticated'>
    <div class="postcard-list-area">
      <ul class="postcard-list"
        v-if="postCardList.length">
        <li v-for="(card, index) in postCardList"
          :key="card.id"
          :index="index"
          :class="{'is-admin': !isMyPostCard(card)}">
          <div class="content">{{ card.data.content }}</div>
          <span class="admin-label">飼育係より</span>
          <span class="date"
            :title="$formLib.dateFormat(card.data.timestamp.toDate(), 'yyyy-m-d HH:MM:ss')"
            v-if="card.data.timestamp">({{ timeAgo(card.data.timestamp.toDate()) }})</span>
        </li>
      </ul>

      <ul class="postcard-list"
        v-if="oldPostCardList.length">
        <li v-for="(card, index) in oldPostCardList"
          :key="card.id"
          :index="index"
          :class="{'is-admin': !isMyPostCard(card)}">
          <div class="content">{{ card.data.content }}</div>
          <span class="admin-label">飼育係より</span>
          <span class="date"
            :title="$formLib.dateFormat(card.data.timestamp.toDate(), 'yyyy-m-d HH:MM:ss')"
            v-if="card.data.timestamp">({{ timeAgo(card.data.timestamp.toDate()) }})</span>
        </li>
      </ul>
      <div v-if="postCardListIsEmpty"
        class="text-center">
        <div v-if="postCardList.length">
          これより古いはがきは見つかりませんでした
        </div>
        <div v-else-if="postCardListisLoaded">
          まだ送られたはがきはありません
        </div>
        <div v-else>
          読み込み中です
        </div>
      </div>
      <div v-else
        class="text-center mt-1">
        <el-button class="button-block"
          :disabled="!lastPostCard"
          @click="loadOldPostCard">もっと読む</el-button>
      </div>
    </div>
  </div>
  <div v-else
    class="guest-message text-center">
    <p>はがきを飼育係に届けるにはログインが必要です。</p>
    <login-forms />
    <div class="contact-form-link"><a :href="contactFormURL" target="_blank" rel="nofollow">ログインせずにお問合せを送る</a></div>
  </div>
</div>
</template>
<style lang="scss">
$white: #fff;
$green: #004D40;
$light-green: #107060;
.postcard-message {
  position: relative;
  max-width: 400px;
  margin: 0 auto;
  &::after {
   content: '';
    display: block;
    background: $green;
    height: 4rem;
    width: 100%;
    border-radius: 0 0 0 5rem;
  }
}
.postcard-message-head {
  background: $green;
  border-radius: 0rem 5rem 0 0;
  padding: .5rem 1rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  .postage-stamp {
    display: flex;
    align-items: center;
    img {
    width: 2rem;
    height: auto;
    }
  }
  .subject {
    margin-left: .5rem;
    color: $white;
    font-feature-settings : "palt";
    letter-spacing: .5px;
  }
}
.postcard-message-body {
  &::before {
    content: "";
    display: block;
    width: 3rem;
    height: .5rem;
    background: lighten($green, 10);
    position: absolute;
    right: -1rem;
    bottom: 0;
    transform: rotate(45deg);
  }
  &::after {
    content: attr(data-counter) "/140";
    position: absolute;
    color: rgba($white, .6);
    bottom: 1.5rem;
    right: 1rem;
  }
  textarea {
    border: none;
    background: lighten($green, 5);
    border-radius: 0;
    color: $white;
    &::placeholder {
      color: rgba($white, .6);
    }
    &:focus {
      border: none;
      outline: solid 1px lighten($green, 15);
    }
    &::-webkit-scrollbar {
      background: lighten($green, 10);
      width: .5rem;
      height: .25rem;
    }
    &::-webkit-scrollbar-track-piece {
      background: lighten($green, 10);
    }
    &::-webkit-scrollbar-thumb {
      background: lighten($green, 20);
      border-radius: .25rem;
    }
  }
}
</style>
<style lang="scss" scoped>
$white: #fff;
$black: #000;
$gray: #dcdfe6;
$green: #004D40;
$light-green: #107060;
$basecolor: #fafafb;
h1{
  font-size: 1.4rem;
}
.container-base {
  max-width: 640px;
}
.yagi-area {
    margin: 1rem 0 0;
}
.postyagi{
  text-align: center;
  min-height: 150px;
  position: relative;
  .yagi-image {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  .message {
    color: #333;
    background: $white;
    border: 1px solid rgba($black, .1);
    border-radius: 1rem;
    padding: 0.25rem 1rem;
    font-size: 0.8rem;
    display: inline-block;
    max-width: 320px;
    position: relative;
    margin-bottom: 1rem;
    &::before {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -10px;
      border: 10px solid transparent;
      border-top: 10px solid rgba($black, .1);
    }
    &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -8px;
      border: 8px solid transparent;
      border-top: 8px solid $white;
      z-index: 1;
    }
  }
}
.postcard {
  background: $white;
  border-radius: 0.25rem;
}
.postcard-header {
  padding: 0.5rem 1rem;
  border-bottom: solid 1px $gray;
  h1 {
    font-size: 1.5rem;
    margin: 0;
  }
  p {
    font-size: 0.875rem;
  }
  a {
    text-decoration: underline;
    &:hover {
      opacity: .9;
    }
  }
}
.postcard-form {
  padding: 1rem;
  position: relative;
  .postcard-form-submit {
    margin: 1rem 0 0;
    text-align: center;
  }
}
.postcard-caution {
  font-size: .875rem;
  margin: .25rem 0;
}
// アニメーション
.input-area.anime {
  width: 100%;
  position: absolute;
  animation-name: anime;
  animation-duration: 1s;
  animation-timing-function: ease-in;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
  top: 0;
  left: 0;
}
@-webkit-keyframes anime {
  0% {
    transform: scale(1) rotate(0deg);
    top: 0;
    left: 0;
  }
  70% {
    left: -100px;
  }
  100% {
    transform: scale(0) rotate(720deg);
    top: -240px;
    left: -35px;
  }
}
.postyagi.success-anime {
  animation-name: success-anime;
  animation-duration: 2s;
  animation-timing-function: ease-in;
  animation-iteration-count: 1;
  animation-delay: 1;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
}
@-webkit-keyframes success-anime {
  0% {
    margin-left: 0;
  }
  30%{
    margin-left: -3000px;
    opacity: 0;
  }
  49%{
    margin-left: -3000px;
  }
  50%{
    margin-left: 3000px;
    opacity: 0;
  }
  100%{
    margin-left: 0;
    opacity: 1;
  }
}
.postyagi.vibrate-anime {
  animation-name: vibrate-anime;
  animation-duration: 0.2s;
  animation-timing-function: ease-in;
  animation-iteration-count: 3;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
}
@-webkit-keyframes vibrate-anime {
  0% {
    transform: rotate(0deg);
  }
  25%{
    transform: rotate(2deg);
  }
  75%{
    transform: rotate(-2deg);
  }
  100%{
    transform: rotate(0deg);
  }
}
// アニメーションここまで
.postcard-list-area {
  background: $white;
  border-radius: 0.25rem;
  margin: 3.5rem 0 2rem;
  padding: 1rem;
}
.postcard-list {
  margin: 1rem 0;
  font-size: .875rem;
  li {
    position: relative;
    background: $green;
    border-radius: 0 3rem 0 3rem;
    color: $white;
    max-width: 15rem;
    min-height: 5rem;
    margin: 0.5rem 0 0.5rem auto;
    padding: 1rem 1.5rem;
    list-style: none;
    line-height: 1.5;
    &::after {
      content: "";
      display: block;
      width: 2rem;
      height: .5rem;
      background: lighten($green, 10);
      position: absolute;
      right: -1rem;
      bottom: 0;
      transform: rotate(45deg);
    }
    @media(max-width: 430px) {
        margin: 0.5rem 0 0.5rem 2rem;
    }
    .admin-label {
        display: none;
        font-size: 0.7em;
    }
    .date {
        font-size: 0.7em;
        color: rgba($white, .8);
    }
  }
  li.is-admin {
    background: $basecolor;
    border: solid 1px $gray;
    border-radius: 3rem 3rem 3rem 0;
    color: rgba(0, 0, 0, 0.75);
    margin-left: 3rem;
    margin-right: auto;
    position: relative;
    &::after {
      display: none;
    }
    &:before {
      content: "";
      display: inline-block;
      position: absolute;
      width: 2.5rem;
      height: 2.5rem;
      border: solid 1px $gray;
      border-radius: 50%;
      background: url("/static/img/radish.svg") no-repeat center center;
      background-size: 2rem 2rem;
      bottom: -1rem;
      left: -3rem;
      @media(max-width: 430px) {
        bottom: 0;
      }
    }
    .admin-label {
      display: inline-block;
      color: rgba($black, .5);
      margin-right: 0.25rem;
    }
    .date {
      color: rgba($black, .5);
    }
  }
}
.guest-message {
  padding: 1rem;
  background: $white;
  p {
    font-size: 0.875rem;
  }
}
.contact-form-link {
  font-size: 0.875rem;
  margin-top: 1rem;
  a {
    text-decoration: underline;
  }
}
</style>
<script>
import timeAgo from '@/assets/lib/time-ago-jp'
import LoginForms from '@/components/LoginForms'
import _ from '@/assets/lib/my-lodash'
const sleep = (waitSeconds, someFunction) => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(someFunction())
    }, waitSeconds)
  })
}
const CLICK_MESSAGES = ['ゆうびんやぎだよ！', 'はがきはまかせて！', '飼育係がまってるよ！', 'おなかすいた！', 'げんきだよ！', 'ごは…おしごとの時間だ！', 'おしごと頑張る！', 'たくさん送って！', 'もっとなでて！', '使ってくれてありがとう！']
const ATE_MESSAGES = ['おいしかった', 'ありがとう', 'まあまあかな', 'うまかった', 'はっぱおいしいね', 'うん、これこれ', 'おしごとたいへん', 'おなかすいてるの', 'おかわりほしいな！']
const ATE_ERROR_MASSAGE = 'エラー:ヤギが食べました。もういちど渡してください'
const SUCCESS_MESSAGE = '無事に送信されました'
const YAGI_MOUNTED_MESSAGE = 'はがきはまかせて！'
const YAGI_SENT_MESSAGES = ['飼育係に渡したよ', 'やるときはやるよ', 'しめい果たした', 'おしごと完了！', 'あさめしまえだね']
const YAGI_SENDING_ERROR_MESSAGE = 'なんかエラー'
const YAGI_RUN_AND_EAT_MESSAGES = ['うんどうだいじ', 'あっちでたべてきた', 'はしりたくなった']
export default {
  components: {
    'login-forms': LoginForms
  },
  data: function () {
    return {
      postCard: {
        content: ''
      },
      postCardListIsEmpty: true,
      postCardRules: {
        content: [{
          required: true,
          message: '本文をいれてね',
          trigger: 'change'
        }, {
          min: 1,
          max: 140,
          message: '140文字以内にしてね',
          trigger: 'change'
        }]
      },
      sendSuccess: false,
      isVibrate: false,
      postYagiMessage: '',
      postYagiMessageTimeout: null,
      postCardList: [],
      postCardListisLoaded: false,
      oldPostCardList: [],
      lastPostCard: null,
      eatRate: 0.99,
      eatRateChaser: 0.99,
      eatCount: 0,
      nowSending: false,
      postCardListUnsubscribe: {},
      chaseEatRateTimer: null
    }
  },
  computed: {
    contactFormURL: () => process.env.VUE_APP_CONTACT_FORM_URL,
    animeClass: function () {
      return {
        anime: this.nowSending
      }
    },
    successPercent: function () {
      let eatPercent = Math.ceil(this.eatRateChaser * 100)
      return 100 - eatPercent
    },
    postyagiClassObj: function () {
      return {
        'success-anime': this.sendSuccess,
        'vibrate-anime': this.isVibrate
      }
    }
  },
  methods: {
    showMessage: function (message, durationMs) {
      const app = this
      if (app.postYagiMessage) {
        console.log('skip')
        return
      }
      if (durationMs === undefined) {
        durationMs = 3000
      }
      app.postYagiMessage = message
      clearTimeout(app.postYagiMessageTimeout)
      app.postYagiMessageTimeout = setTimeout(function () {
        app.postYagiMessage = ''
      }, durationMs)
    },
    vibrateYagi: async function () {
      const app = this
      app.isVibrate = true
      await sleep(1000, () => {
        app.isVibrate = false
      })
    },
    isMyPostCard: function (postCard) {
      if (!this.$firebase.user) {
        return false
      }
      if (this.$firebase.user.uid === postCard.data.author.uid) {
        return true
      }
    },
    timeAgo: function (date) {
      return timeAgo(date)
    },
    showClickMessage: function () {
      return this.showMessage(_.sample(CLICK_MESSAGES), 1500)
    },
    getAteMessage: function () {
      return _.sample(ATE_MESSAGES)
    },
    reduceEatRateByRandom: function () {
      this.eatRate = 1 - ((1 - this.eatRate) * Math.random())
    },
    updateEatRateByContent: function (content) {
      const uniqueChars = content.split('').filter((x, i, self) => self.indexOf(x) === i)
      const uniqueCharsCount = uniqueChars.length
      let baseScale = 1
      if (uniqueCharsCount > 8) {
        baseScale = 1.3
      } else if (uniqueCharsCount > 4) {
        baseScale = 0.9
      } else {
        baseScale = 0.6
      }
      let scale = baseScale * Math.random() + 1
      this.eatRate = this.eatRate / scale
    },
    passPostCard: function () {
      if (this.$firebase.isAuthenticated) {
        this.sendPostCard()
      } else {
        this.runAndEatPostCard()
      }
    },
    runAndEatPostCard: async function () {
      this.nowSending = true
      const app = this
      this.$refs['postCardForm'].validate(async valid => {
        if (!valid) {
          console.log('postCardForm is not valid')
          app.nowSending = false
          return false
        }
        const tmpContent = this.postCard.content
        await sleep(1500, () => {})
        app.vibrateYagi()
        await sleep(1500, () => {})
        app.$refs['postCardForm'].resetFields()
        const rand = Math.random()
        if (rand < app.eatRate) {
          // 食べたとき
          app.updateEatRateByContent(tmpContent)
          // app.eatRate = app.eatRate / 2
          app.eatCount++
          app.showMessage(app.getAteMessage())
          await sleep(1000, () => {})
          app.$message({
            message: ATE_ERROR_MASSAGE,
            type: 'error'
          })
          app.$gtm.sendError('yagi', `yagi ate postcard! count:${app.eatCount}, message:${tmpContent}`)
          app.postCard.content = tmpContent
          await sleep(1000, () => {})
          app.nowSending = false
          return
        }
        // はしったとき
        app.sendSuccess = true
        app.reduceEatRateByRandom()
        await sleep(2500, () => {
          app.sendSuccess = false
        })
        app.$refs['postCardForm'].resetFields()
        app.showMessage(_.sample(YAGI_RUN_AND_EAT_MESSAGES))
        await sleep(1000, () => {})
        app.$message({
          message: 'やっぱり食べました。飼育係に届けるにはログインが必要です',
          type: 'error'
        })
        app.postCard.content = tmpContent
        app.nowSending = false
      })
    },
    sendPostCard: async function () {
      this.nowSending = true
      const app = this
      this.$refs['postCardForm'].validate(async valid => {
        if (!valid) {
          console.log('postCardForm is not valid')
          app.nowSending = false
          return false
        }
        const tmpContent = this.postCard.content
        await sleep(1500, () => {})
        app.vibrateYagi()
        await sleep(1500, () => {})
        app.$refs['postCardForm'].resetFields()
        const rand = Math.random()
        if (rand < app.eatRate) {
          // 食べたとき
          app.updateEatRateByContent(tmpContent)
          // app.eatRate = app.eatRate / 2
          app.eatCount++
          app.showMessage(app.getAteMessage())
          await sleep(1000, () => {})
          app.$message({
            message: ATE_ERROR_MASSAGE,
            type: 'error'
          })
          app.$gtm.sendError('yagi', `yagi ate postcard! count:${app.eatCount}, message:${tmpContent}`)
          app.postCard.content = tmpContent
          await sleep(1000, () => {})
          app.nowSending = false
          return
        }
        // 食べなかったとき
        app.$firebase.addPostCard(tmpContent).then(async function () {
          app.sendSuccess = true
          app.reduceEatRateByRandom()
          await sleep(2500, () => {
            app.sendSuccess = false
          })

          app.$refs['postCardForm'].resetFields()
          app.showMessage(_.sample(YAGI_SENT_MESSAGES))
          await sleep(1000, () => {})
          app.$message({
            message: SUCCESS_MESSAGE,
            type: 'success'
          })
        }).catch(err => {
          console.error(err)
          app.showMessage(YAGI_SENDING_ERROR_MESSAGE)
        }).finally(() => {
          app.nowSending = false
        })
      })
    },
    updatePostCardList: function (snapshot) {
      const app = this
      app.postCardListisLoaded = true
      app.postCardListIsEmpty = snapshot.empty
      if (snapshot.empty) {
        return
      }
      app.postCardList = []
      snapshot.docs.forEach(function (doc) {
        app.postCardList.push({
          id: doc.id,
          data: doc.data()
        })
      })
      if (!this.lastPostCard && snapshot.docs.length) {
        this.lastPostCard = snapshot.docs[snapshot.docs.length - 1]
      }
    },
    loadOldPostCard: function () {
      if (!this.lastPostCard) {
        console.error('this.lastPostCard is empty')
        return
      }
      const app = this
      this.$firebase.getPostCardList(this.lastPostCard)
        .then(function (snapshot) {
          app.postCardListIsEmpty = snapshot.empty
          if (snapshot.empty) {
            return
          }
          snapshot.docs.forEach(function (doc) {
            app.oldPostCardList.push({
              id: doc.id,
              data: doc.data()
            })
          })
          if (snapshot.docs.length) {
            app.lastPostCard = snapshot.docs[snapshot.docs.length - 1]
          }
        })
        .catch(err => console.error(err))
    },
    listenPostCardList: function () {
      // https://firebase.google.com/docs/firestore/query-data/listen?hl=ja
      if (typeof this.postCardListUnsubscribe === 'function') {
        console.log('postCardListUnsubscribe')
        this.postCardListUnsubscribe()
      } else {
        console.log('listenPostCardList')
        this.postCardListUnsubscribe = this.$firebase.getPostCardListOnSnapshot(this.updatePostCardList)
      }
    },
    chaseEatRate: function () {
      const step = 0.01
      if (this.eatRate - step > this.eatRateChaser) {
        this.eatRateChaser += step
      } else if (this.eatRate + step < this.eatRateChaser) {
        this.eatRateChaser -= step
      }
    }
  },
  mounted: function () {
    this.showMessage(YAGI_MOUNTED_MESSAGE)
    this.$eventHub.$on('firebase-initialized', this.listenPostCardList)
    this.listenPostCardList()
    this.chaseEatRateTimer = setInterval(this.chaseEatRate, 50)
  },
  destroyed: function () {
    this.$eventHub.$off('firebase-initialized', this.listenPostCardList)
    if (typeof this.postCardListUnsubscribe === 'function') {
      console.log('postCardListUnsubscribe')
      this.postCardListUnsubscribe()
    }
    clearInterval(this.chaseEatRateTimer)
  }
}
</script>
